import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Caught error:", error);
    console.error("[ErrorBoundary] Component stack:", info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    if (this.props.fallback) {
      return typeof this.props.fallback === "function"
        ? this.props.fallback({ error: this.state.error, retry: this.handleRetry })
        : this.props.fallback;
    }

    const isLight =
      document.documentElement.getAttribute("data-theme") === "light";

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 40,
          gap: 16,
          minHeight: 200,
          color: isLight ? "#374151" : "#d1d5db",
        }}
      >
        <AlertTriangle
          size={40}
          color={isLight ? "#d97706" : "#fbbf24"}
        />
        <h3
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 600,
            color: isLight ? "#111827" : "#f3f4f6",
          }}
        >
          Something went wrong
        </h3>
        <p
          style={{
            margin: 0,
            fontSize: 14,
            textAlign: "center",
            maxWidth: 400,
            opacity: 0.7,
          }}
        >
          An unexpected error occurred while rendering this section. You can try
          again or refresh the page.
        </p>
        <button
          onClick={this.handleRetry}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "8px 16px",
            fontSize: 14,
            fontWeight: 500,
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
            backgroundColor: isLight ? "#2563eb" : "#3b82f6",
            color: "#fff",
          }}
        >
          <RefreshCw size={14} />
          Try Again
        </button>
      </div>
    );
  }
}
